import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/fonts.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// Security protection remains necessary in configured registration forms.
window.recaptchaOptions = { ...window.recaptchaOptions, useRecaptchaNet: true };

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
